(function() {
    'use strict';
    var dl_OBJ011 = document.querySelector('[dataLayer~=OBJ011]');

    if (dl_OBJ011) {
        var userHasScrolled = false;

        window.addEventListener('scroll', function() {
            if (!userHasScrolled) {
                OBJ011();
                userHasScrolled = true;
            }
        });
    }

    function OBJ011() {
        var data = createch_data.page.ecommerce.detail.products[0];

        dataLayer.push({
            "object": {
                "Id": "OBJ011",
                "name": "Blog - Add to cart"
            },
            "event": "ecommerceAction",
            "ecommerce": {
                "currencyCode": "CAD",
                "add": {
                    "products": [
                        {
                            "name": data.name.trim(),
                            "id": data.id,
                            "price": "1",
                            "brand": "createch canada",
                            "category": data.category,
                            "variant": data.variant,
                            "quantity": "1"
                        }
                    ]
                }
            }
        });
    }

})();
